// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__2dWLA","logo":"Logo_logo__30xDu","version":"Logo_version__132gf"};